import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

// Interfaces
import { ICourse, IChapter } from "store/StateInterfaces";

// Components
import CourseDeleteModal from 'Screens/CoursesList/Common/Components/CourseDeleteModal';
import Switch from 'react-switch'

// Assets
import '../../Common/Assets/course.sass';
import { downloadCourse, loadCoursesListRequest } from "../Actions/Actions";


interface IProps {
  course: ICourse;
  publishCourse: (number) => void;
  deleteCourse: (number) => void;
  downloadCourse: (number, any) => void;
  loadArchiveStatus: (number) => void;
  deleteArchive: (number) => void;
  toggleArchive: (number) => void;
}

const Course = (props: IProps) => {
  let course = props.course;
  let formatter = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  var start_date = 'N/A';
  console.log("here", course.start_date);
  if (course.start_date != "Not Decided")
    start_date = formatter.format(Date.parse(course.start_date))
  console.log(start_date)
  // course.start_date = formatter.format(Date.parse(course.start_date))
  var display_content;
  var show_other_labs = <div></div>;
  if (course.other_labs.length != 0) {
    show_other_labs = <div>
      <input type="checkbox" className="chapters" value="other_labs"></input> Other Labs
      <hr></hr>
    </div>;
  }
  let form = course.chapters.map((chapter) => {
    return (
      <div key={chapter.id}>
        <input type="checkbox" className="chapters" value={chapter.id} defaultChecked={true}></input> {chapter.title}
        <br></br>
      </div>
    )
  })
  display_content = form
  if (form.length == 0) {
    display_content = <div><h6 className="text-center">No content to download</h6></div>
  } else {
    display_content = (<div>
      <div className="modal-body">
        <h6>Select Content to Download/Share/Import: </h6>
        <form className="form" method="POST" id={'archive-form' + course.id}>
          {/* <input type="checkbox" className="chapters" value="prog_assign"></input> Programming Assignment
          <a className="col-sm-3"
            data-toggle='modal'
            data-dismiss="modal"
            href="#"
            data-target={'#course-download-form-pa'+course.id} >
              (click here to select)
          </a>
          <hr></hr> */}
          {show_other_labs}
          {form}
        </form>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary download-archive-btn" onClick={() => { handleDownload(course.id, props.downloadCourse) }}>Start Download</button>
      </div>
    </div>)
  }

  if (course.archive.progress == 'Submitted') {
    React.useEffect(() => {
      let interval = setInterval(() => {
        props.loadArchiveStatus(course.id);
      }, 10000);
      setTimeout(() => {
        clearInterval(interval);
      }, 10000);
      return () => clearInterval(interval);
    });
  }
  var modal_content;
  if (course.archive.progress == 'Submitted') {
    modal_content = (
      <div>
        <div className='modal-body'>
          <img className="load-download" src={"/static/img/spin.gif"}></img>
          <br></br>&nbsp;
          <br></br>
          <h6 className="text-center">Download will take time and is in progress in background.<br></br>Click on the download icon to check progress.</h6>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-dismiss="modal">OK</button>
        </div>
      </div>
    )
  } else if (course.archive.progress == 'not_present') {
    modal_content = <div>{display_content}</div>
  } else if (course.archive.error != '') {
    modal_content = (
      <div className="modal-body">
        <h5>Error Occured</h5>
        <strong>Message: </strong>
        {course.archive.error}
        <br></br>
          Delete : <a href="#" onClick={() => props.deleteArchive(course.id)}>Link</a>
      </div>
    )
  } else {
    modal_content = (
      <div className="modal-body">
        <h5>Course Export details</h5>
        <h6>Course: <strong>{course.title}</strong> ready to download. </h6>
        Link to download/share/import: <a href={'/courseware/download_archive/' + course.archive.link}><p>{window.location.protocol + "//" + window.location.host + "/courseware/download_archive/" + course.archive.link}</p></a>
        {/* Status : {course.archive.active?(<span>Active <a href="#" onClick={()=>props.toggleArchive(course.id)}>Click here to disable</a></span>):(<span>Inactive <a href="#" onClick={()=>props.toggleArchive(course.id)}>Click here to enable</a></span>)} <br></br> */}
        Active:<Switch className="active-switch" onChange={() => props.toggleArchive(course.id)} checked={course.archive.active} height={22} /><br></br>
        {/* Delete : <a href="#" onClick={()=>props.deleteArchive(course.id)}>Link</a> */}
        Delete:
        <span className="del-ico">
          <button className="material-icons icon db-delete"
            onClick={() => props.deleteArchive(course.id)}> delete
          </button>
        </span>

        <ol>
          <li>Click on link to download a zipped folder of the course content.</li>
          <li>Copy URL to share with friends for them to download. Ensure Link is "<strong>Active</strong>".</li>
          <li><strong>Avoid unecessary large download (you or friends). If goal is to copy course content to another course on Bodhitree, just copy/paste this link during course creation (Add course button) or in an existing course (Import Content button).</strong></li>
        </ol>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="modal fade archive-download-form" id={"course-download-form" + course.id} role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="form">
          <div className="modal-content">
            <div className="closeButton-container">
              <button type="button" className="closeButton" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {modal_content}
          </div>
        </div>
      </div>


      <div className="dashboard col-md-3 col-sm-4">
        <div className="dashboard-container" id={`course.id`}>
          <div className="db-info" onClick={() => handleClicks(props)}>
            <div className="opacity"></div>
            <div className="db-info-label"> {course.enrollment_type == "O" ? "Open Course" : "Moderated Course"}
              <span
                data-toggle="tooltip"
                title={course.enrollment_type == "O" ? "Course open to public." : "Course open only to approved students."}
                // style={{font-size:1rem}}
                className="material-icons icon info-icon">help_outline</span>
            </div>
            <div className="db-userInfo"> I</div>
            <div className="db-courseImageContainer">
              {course.image ? (<img className="courseImage" src={course.image} />) : (
                <img className="courseImage" src={"/static/img/no_image.png"} />
              )}
            </div>
          </div>

          <div className="db-courseLabel" title={course.title} onClick={() => handleClicks(props)}>{course.courseCode}: {course.title}</div>
          <div className="row">

            {course.is_published ?
              (<button className="db-publish db-unpublish col-sm-6" onClick={() => props.publishCourse(course.id)}> UnPublish </button>) :

              (<button className="db-publish col-sm-6" onClick={() => props.publishCourse(course.id)}> Publish </button>)
            }

            <button className="material-icons icon db-cloud_download col-sm-3"
              data-toggle='modal'
              data-target={'#course-download-form' + course.id} >
              {" "}
                cloud_download{" "}
            </button>

            <button data-toggle="modal" className="material-icons icon db-delete col-sm-3"
              onClick={() => props.deleteCourse(course.id)}> delete
              </button>
          </div>
          <div className="d-flex flex-row db-footerLabel">
            <div style={{ width: '50%' }}>
              <span className="db-courseCreated">From <span title={course.institute?.name} className="db-institute">{course.institute?.name != null ? course.institute?.name : "Other"}</span></span>
            </div>
            <div style={{ width: '50%' }}>
              <span className="db-courseUpdated">Created {start_date != "" ? start_date : "01/01/2020"}</span>
            </div>
          </div>
          {/* <div className="db-footerLabel db-offeredBy">
              <span className=""> Offered by:</span>
              <span className="db-institute"> {course.institute.name}</span>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

const handleClicks = props => {
  window.location.href = `/courseware/course/${props.course.id}/`;
};

const handleDownload = (courseId, downloadCourse) => {
  let chapters = [];
  let p_assigns = [];
  let form = document.getElementById('archive-form' + courseId);
  let chaptersinp = form.getElementsByTagName('input');
  let assign_checked = false;
  for (var i = 0; i < chaptersinp.length; i++) {
    if (chaptersinp[i].checked) {
      chapters.push(chaptersinp[i].value);
      if (chaptersinp[i].value == "prog_assign") {
        assign_checked = true;
      }
    }
  }
  if (assign_checked == true) {
    let pa_form = document.getElementById('archive-form-pa' + courseId);
    let pa_inp = pa_form.getElementsByTagName('input');
    for (var i = 0; i < pa_inp.length; i++) {
      if (pa_inp[i].checked) {
        p_assigns.push(pa_inp[i].value);
      }
    }
  }

  downloadCourse(courseId, chapters, p_assigns);
  return true;

}
export default Course;
